<template>
  <div>
    <BreadCrumb
      :path="[
        {
          title: documentData?.organization?.name || userData?.name,
          route: documentData?.organization?.name
            ? `/organization/${documentData?.organization?._id}`
            : '/account',
        },
        {
          title: documentData?.title,
          route: this.$router.routesMap.Debate(documentData?._id),
        },
        {
          title: 'Debate Details',
          route: `/document-details/${documentData?._id}`,
        },
        {
          title: 'Team Settings',
          route: `/team-settings/${documentData?._id}/${teamID}`,
        },
        {
          title: teamMemberName,
          route: `/team-member-details/`,
        },
      ]"
    />
    <MainContentPanel :title="`Member Activity: ${teamMemberName}`" padding="small">
      <div v-if="uiMode === 'details'">
        <PrimeDataTable
          :tableOptions="tableOptions"
          :tableConfig="tableConfig"
          :loadDataFunction="getMemberDocuments"
          @selectedColumns="tableToggleData"
        />
      </div>
    </MainContentPanel>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import MainContentPanel from '@/components/display/general/MainContentPanel.vue';
import BreadCrumb from '@/components/general/BreadCrumb.vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import { xhr } from '@/xhr/endpoints';

export default {
  name: 'TeamMember',
  components: {
    MainContentPanel,
    PrimeDataTable: defineAsyncComponent(() => import('@/components/table/PrimeDataTable.vue')),
    BreadCrumb,
  },
  data() {
    return {
      personData: {},
      teamMemberName: '',
    };
  },

  computed: {
    ...mapState(['idToken', 'userData', 'documentData', 'currentTeamMemberID', 'currentTeam']),

    ...mapGetters(['teamID', 'documentMode', 'teamMembers', 'tableToggleData']),
    tableOptions() {
      return {
        tableName: 'tableTeamMember',
      };
    },
    tableConfig() {
      const table = [
        {
          column: 'Debate Title',
          field: 'document.title',
          type: 'link',
          model: row => row.document.title,
          link: row => this.$router.routesMap.Debate(row.document._id),
          sortable: true,
          index: 1,
        },
        {
          column: 'Insights',
          customIcon: '/icons/icon-Information.svg',
          customIconLink: this.adminMode
            ? undefined
            : row => `/document-details/${row.document._id}`,
          customIconAction: this.adminMode
            ? row => this.$emit('adminModeNavigate', `/document-details/${row.document._id}`)
            : undefined,
          index: 2,
        },
        {
          column: 'Round Status',
          field: 'team_latest_round',
          model: row => {
            return `${row.team_latest_round}-${row.team_round_status}`;
          },
          index: 3,
        },
        {
          column: 'Response Ratio',
          columnTooltip:
            'The total number of responses provided over the total number of Team Lead Instructions',
          field: 'responseRatio.replies',
          icon: 'comment',
          model: row => `${row.responseRatio.replies} / ${row.responseRatio.total}`,
          sortable: true,
          index: 4,
        },
        {
          column: 'Selection Ratio',
          columnTooltip:
            'The total number of responses or voluntary annotations Team Lead has accepted over the total number possible',
          field: 'selectionRatio.replies',
          icon: 'comment',
          model: row => `${row.selectionRatio.replies} / ${row.selectionRatio.total}`,
          sortable: true,
          index: 5,
        },
      ];
      return table;
    },
    uiMode() {
      return this.currentTeamMemberID ? 'details' : 'new';
    },
    saveButtonText() {
      return this.uiMode === 'details' ? 'Save Changes' : 'Request to Join';
    },
  },
  mounted() {
    const memberData = this.currentTeam.members.filter(
      data => data.user._id === this.currentTeamMemberID
    );
    this.teamMemberName = memberData[0].firstname + ' ' + memberData[0].lastname;
  },
  methods: {
    ...mapActions(['showSavingLoader', 'hideLoader']),
    async getMemberDocuments({ page, sortColumn, sortDirection, filters }) {
      const res = await xhr.getUserSummary(
        this.currentTeamMemberID,
        page,
        sortColumn,
        sortDirection,
        filters
      );
      this.personData = res;
      return this.personData;
    },

    getCounterpointValue(field) {
      return !this.documentData?.counterpoint && this.documentData.counterpoint[0]
        ? this.documentData.counterpoint[0][field]
        : 0;
    },

    submitForm() {
      if (this.uiMode === 'new') {
        this.create();
      } else {
        this.edit();
      }
    },

    async clickRemoveFromTeam(row) {
      try {
        // console.log(JSON.parse(JSON.stringify(row)));
        await xhr.removeTeamMembers(row.team._id, this.currentTeamMemberID, this.idToken);
        this.personData.documents = this.personData.documents.filter(
          x => x.document._id !== row.document._id
        );
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="sass">
.error
  input
    border-color: red
</style>
